import React,{ useState,useEffect } from "react";
import { OverlayTrigger, Tooltip } from "react-bootstrap";


const NetworkIconsSection = ({ networkList }) => {
    const [feedIcon,setFeedIcon] = useState([]);
    useEffect(()=>{
 
          const temp = [...new Set(networkList)];
     
          setFeedIcon(temp)
       },[])
    return <h6 className="text-center mb-0 social-network p_tooltip d-flex justify-content-center">
        <div className="symbol-group symbol-hover">
            {
                feedIcon.length >= 3 ? <>
                    <div className="symbol symbol-30 symbol-circle" data-toggle="tooltip" title="">
                        <span className="symbol-label"><i className={`fab ${feedIcon[0]}`} /></span>
                    </div>
                    <div className="symbol symbol-30 symbol-circle" data-toggle="tooltip" title="">
                        <span className="symbol-label"><i className={`fab ${feedIcon[1]}`} /></span>
                    </div>
                    <OverlayTrigger
                        placement='top'
                        overlay={
                            <Tooltip className="light">
                                <div className="tooltip_symbol d-flex flex-wrap">
                                    {
                                        feedIcon.slice(2, feedIcon.length).map((networkIcon) => (<div className="symbol symbol-30 symbol-circle" data-toggle="tooltip" title="">
                                                <span className="symbol-label"><i className={`fab ${networkIcon}`} /></span>
                                            </div>
                                        ))
                                    }
                                </div>
                            </Tooltip>
                        }
                    >
                        <div className="symbol symbol-30 symbol-circle symbol-light">
                            <span className="symbol-label font-weight-bold text-dark font-size-sm">{`${feedIcon.length - 2}+`}</span>
                        </div>
                    </OverlayTrigger>
                </> :
                <>
                    {
                        feedIcon.map((networkIcon) =>(<div className="symbol symbol-30 symbol-circle symbol-light">
                        <span className="symbol-label font-weight-bold text-dark font-size-sm"><i className={`fab ${networkIcon}`} /></span>
                    </div>))
                    }
                    </>
            }
        </div>
    </h6>
}

export default NetworkIconsSection;